import {
  FEATURE_BIOBANK,
  FEATURE_FIMLAB,
  isFeatureOn,
} from '../../definitions/Config';
import { executeAllPromises } from '../util';
import { getServices } from '../service/actions';
import {
  getAppointmentReservationClinics,
  getAppointments,
  getQueueAppointments,
} from '../appointment/actions';
import { doGetFimlabLaboratories } from '../fimlab/actions';
import {
  getTimelineEventsAndQuestionnaires,
  updateTimelineShowPastEvents,
} from '../../views/timeline/data/actions';

import Logger from '../../utils/Logger';
import {
  doGetGlobalNotifications,
  doGetNotifications,
} from '../notification/actions';
import { startPolling } from '../poller';
import { doGetConsentStatus } from '../biobank/actions';
import { selectIsHpa } from '../hpa/selectors';
import { fetchAssignedForms } from '../questionnaires/actions';
import { doGetCareConversationMessageUnreadCount } from "../flowmedik/actions";
import {doGetGenericPhrases} from "../../views/timelineframe/data/actions";

let { id: module_id } = module;
const logger = new Logger(module_id);

let createActionName = require('../util').createActionName('application');

export const APPLICATION_INITIALIZED = createActionName(
  'APPLICATION_INITIALIZED'
);
export const APPLICATION_INITIALIZATION_FAILED = createActionName(
  'APPLICATION_INITIALIZATION_FAILED'
);

export const applicationInitialized = () => ({
  type: APPLICATION_INITIALIZED,
});

export const applicationInitializationFailed = () => ({
  type: APPLICATION_INITIALIZATION_FAILED,
});

// Initialize application after successful registration and login.
export const initializeLoggedInApplication =
  () => (dispatch, getState, services) => {
    let isHpa = selectIsHpa(getState());

    /*dispatch(getPatientRelatives());*/
    dispatch(getAppointments());
    dispatch(getQueueAppointments());
    dispatch(getAppointmentReservationClinics());
    dispatch(doGetGlobalNotifications());
    dispatch(doGetGenericPhrases());

    /* some actions need to be run before trying to fetch notifications. These
     are called as a batch, and after every one has returned (failing or not)
     fetch notifications.
    */
    let promisesBeforeNotifications = [];

    promisesBeforeNotifications.push(
      dispatch(doGetCareConversationMessageUnreadCount()),
      dispatch(getTimelineEventsAndQuestionnaires()),
      dispatch(getServices())
    );

    if (isFeatureOn(FEATURE_FIMLAB)) {
      // fetching fimlab laboratories is currently dependent on the feature
      // switch being on.
      promisesBeforeNotifications.push(dispatch(doGetFimlabLaboratories()));
    }

    if (isFeatureOn(FEATURE_BIOBANK) && !isHpa) {
      dispatch(doGetConsentStatus());
    }

    executeAllPromises(promisesBeforeNotifications).then((items) => {
        executeAllPromises([dispatch(fetchAssignedForms())]).then((items) => {
            dispatch(doGetNotifications())
                .then((action) => {
                    // show past events is called either way
                    dispatch(updateTimelineShowPastEvents());
                })
                .catch((error) => {
                    // show past events is called either way
                    dispatch(updateTimelineShowPastEvents());
                    logger.error(error);
                });

            // Starts to poll unread messages from Flowmedik
            startPolling(
                'doGetCareConversationMessageUnreadCount',
                () => dispatch(doGetCareConversationMessageUnreadCount()),
                120000
            );
        });
    });
  };
